import React from "react";
import { useNavigate } from "react-router-dom";
import { BitmakerAPIClient } from "../../services/BitmakerApp";
import { Account } from "../../bitmaker/schemas/Account";

interface Props {
  navigate: (path: string) => void;
}

interface State {
  accounts: Array<Account>;
  redirectTo?: string;
}

class AccountsDashboardContent extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      accounts: [],
      redirectTo: undefined,
    };
  }

  componentDidMount() {
    const handleAccounts = (response: any) => {
      this.setState({
        accounts: response.data,
      });
    };
    BitmakerAPIClient.get("/accounts", null, handleAccounts);
  }

  componentDidUpdate(_: Props, prevState: State) {
    if (
      this.state.redirectTo &&
      this.state.redirectTo !== prevState.redirectTo
    ) {
      // Si redirectTo se establece, usamos el prop 'navigate' inyectado
      this.props.navigate(this.state.redirectTo);
    }
  }

  public render() {
    const projects = this.state.accounts.map((account) => {
      return (
        <div className="project-card" key={account.id}>
          <button
            onClick={() =>
              this.setState({ redirectTo: `/accounts/${account.name}` })
            }
          >
            {account.name}
          </button>
        </div>
      );
    });
    return <div className="projects-dashboard">{projects}</div>;
  }
}

export const AccountsDashboard = () => {
  const navigate = useNavigate();
  return <AccountsDashboardContent navigate={navigate} />;
};
